//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import getNavigationUser from '~/config/navigationUser';

export default {
  computed: {
    ...mapState('user', ['user']),

    userId() {
      const { id } = this.user;
      if (id) {
        return `Id: ${id}`;
      }
      return '';
    },

    menu() {
      return getNavigationUser();
    },
  },

  methods: {
    isCurrentRoute(name) {
      const currentRouteName = this.$route.name;
      return (name === currentRouteName);
    },
  },
};
